import { collectionPath, defineModelSpec, orderBy } from '@elara/firebolt/shared';

import { HotelDataSchema } from './schemas/hotel-schemas.js';
import { id } from './schemas/zod-types.js';

/**
 * The canonical `ModelSpec` for the hotels collection.
 * It defines the path (`hotels/{id}`) and the data shape for a hotel document.
 * Hotels are the primary accommodation entities in the system, containing
 * detailed information about properties, amenities, and ratings.
 */
export const HotelModelSpec = defineModelSpec({
  path: collectionPath`hotels/${id}`,
  shape: HotelDataSchema.shape,
  constraints: [orderBy('rating', 'desc'), orderBy('name')],
});

export type HotelModelSpec = typeof HotelModelSpec;
